








































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class ImportLogComponent extends Vue {
  @Prop() validations: Array<any>;
  @Prop() valiadationImport: boolean = false;

  dialog: boolean = false;

  /*errTypes: Array<any> = [
    { key: "formula", title: "Formula Errors" },
    { key: "invalid_lineItem", title: "Invalid Line Items" },
    { key: "type_mismatch", title: "Invalid Data Types" },
    { key: "invalid_data", title: "Validation Errors" },
  ];*/

  get errTypes() {
    let data = [
      { key: "formula", title: "Formula Errors" },
      { key: "invalid_lineItem", title: "Invalid Line Items" },
      { key: "type_mismatch", title: "Invalid Data Types" },
      { key: "invalid_data", title: "Validation Errors" },
    ];

    return data.map(x =>  {
       return {"key" :x.key, "title" : this.$t(x.title).toString()} 
      });
  }
}
